//export const API_BASE_URL = 'https://localhost:44323/api/v1'; 
export const API_BASE_URL = 'https://cij3b8xauj.execute-api.ap-south-1.amazonaws.com/Prod/api/v1'; 
